import { createTheme } from "@mui/material/styles";

const muiTheme = createTheme({
  palette: {
    primary: { main: "#1976d2" },
    secondary: { main: "#9c27b0" },

    // #6E6E6E
    // #C0C0C0
    // #FF6600
    // #D72638
    // #F5C400
    // #F5F5F5
    // #003366
  },
  typography: {
    h1: { fontSize: "2rem" },
  },
});

export default muiTheme;
